<template>
  <van-tabbar v-model="active" class="bottom" @change="onTabChange">
    <!-- 首页 -->
    <van-tabbar-item>
      <template #icon="props">
        <img
          :src="props.active ? homeActive : homeInactive"
          alt="首页"
          class="tab-icon"
        />
      </template>
      首页
    </van-tabbar-item>

    <!-- 会议详情 -->
    <van-tabbar-item>
      <template #icon="props">
        <img
          :src="props.active ? meetingActive : meetingInactive"
          alt="会议详情"
          class="tab-icon"
        />
      </template>
      会议详情
    </van-tabbar-item>

    <!-- 服务中心 -->
    <van-tabbar-item>
      <template #icon="props">
        <img
          :src="props.active ? serviceActive : serviceInactive"
          alt="服务中心"
          class="tab-icon"
        />
      </template>
      服务中心
    </van-tabbar-item>

    <!-- 座次查询 -->
    <van-tabbar-item>
      <template #icon="props">
        <img
          :src="props.active ? seatsActive : seatsInactive"
          alt="座次查询"
          class="tab-icon"
        />
      </template>
      座次查询
    </van-tabbar-item>
  </van-tabbar>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';

// 底部 tab 图标（请根据实际文件名放到 src/assets/images/ 下）
import homeActive from '../assets/images/tab-home-active.png';
import homeInactive from '../assets/images/tab-home-inactive.png';
import meetingActive from '../assets/images/tab-meeting-active.png';
import meetingInactive from '../assets/images/tab-meeting-inactive.png';
import serviceActive from '../assets/images/tab-service-active.png';
import serviceInactive from '../assets/images/tab-service-inactive.png';
import seatsActive from '../assets/images/tab-seats-active.png';
import seatsInactive from '../assets/images/tab-seats-inactive.png';

const router = useRouter();
const route = useRoute();

const routesMap = {
  home: 0,
  meeting: 1,
  service: 2,
  seats: 3,
};

// 根据当前路由初始化 active
const active = ref(routesMap[route.name] || 0);

// 监听路由变化，同步激活 tab
watch(
  () => route.name,
  (newRouteName) => {
    if (newRouteName in routesMap) {
      active.value = routesMap[newRouteName];
    }
  }
);

const onTabChange = (index) => {
  const routeNames = Object.keys(routesMap);
  const routeName = routeNames[index];
  router.push({ name: routeName });
  active.value = index;
};
</script>

<style scoped>
.bottom {
  padding-bottom: 8px !important;
}

.tab-icon {
  width: 24px;
  height: 24px;
  display: block;
}
</style>